import { useI18n } from '../../i18n'
import { pressureColor } from '../../utils/operationalUx'
import entStyles from '../../styles/enterprise/EnterpriseOperationalUx.module.scss'
import styles from '../../styles/components/assets/AssetsDataMap.module.scss'

type Props = {
  pressure?: string | null
  degraded?: boolean
  staleEvidence?: boolean
  criticalData?: boolean
  runtimeWarning?: boolean
  drift?: boolean
  compact?: boolean
}

export default function DataMapOperationalIndicators({
  pressure,
  degraded,
  staleEvidence,
  criticalData,
  runtimeWarning,
  drift,
  compact,
}: Props) {
  const { t } = useI18n()
  const wrap = compact ? styles.indicatorRowCompact : styles.indicatorRow

  return (
    <div className={wrap} aria-label={t('enterpriseOperationalUx.dataMap.operationalIndicators', 'Operational indicators')}>
      {criticalData ? (
        <span className={`${styles.indicatorChip} ${styles.indicatorCritical}`} title={t('enterpriseOperationalUx.dataMap.criticalDataFlow', 'Critical data flow')}>
          {t('enterpriseOperationalUx.dataMap.criticalShort', 'Critical')}
        </span>
      ) : null}
      {pressure && pressure !== 'LOW' ? (
        <span
          className={`${entStyles.badgePressureHigh} ${styles.indicatorChip}`}
          style={{ color: pressureColor(pressure), borderColor: pressureColor(pressure) }}
          title={t('enterpriseOperationalUx.dataMap.topologyPressure', 'Topology pressure')}
        >
          {pressure}
        </span>
      ) : null}
      {degraded ? (
        <span className={`${styles.indicatorChip} ${styles.indicatorDegraded}`} title={t('enterpriseOperationalUx.dataMap.degradedFlow', 'Degraded flow')}>
          {t('enterpriseOperationalUx.degradedShort', 'degraded')}
        </span>
      ) : null}
      {staleEvidence ? (
        <span className={`${styles.indicatorChip} ${styles.indicatorStale}`} title={t('enterpriseOperationalUx.staleEvidence', 'Stale evidence')}>
          {t('enterpriseOperationalUx.dataMap.staleShort', 'stale')}
        </span>
      ) : null}
      {runtimeWarning ? (
        <span className={styles.runtimeDot} title={t('enterpriseOperationalUx.dataMap.runtimePropagation', 'Runtime propagation')} aria-hidden />
      ) : null}
      {drift ? (
        <span className={`${styles.indicatorChip} ${styles.indicatorDrift}`} title={t('enterpriseOperationalUx.dataMap.flowInstability', 'Flow instability')}>
          {t('enterpriseOperationalUx.dataMap.driftShort', 'drift')}
        </span>
      ) : null}
    </div>
  )
}
